import croPoints from '../../data/whyTikTok.json';


export default function Section7() {


    return (
        <div className="SectionCRO py-[0px] md:py-[30px] bg-[#f9f9f9]">
            {/* Section Heading */}
            <div className="text-center mb-16 max-w-4xl mx-auto">
                <h2 className="text-[26px] md:text-[30px] font-bold text-[#151515] leading-[32px] md:leading-[41px]">
                    Why TikTok Marketing Matters in the UAE
                </h2>
                <p className="mt-4 text-[#555] text-[16px] md:text-[18px] max-w-[600px] mx-auto">
                    With millions of active users across the UAE, TikTok is more than a trend-setting platform, it is a powerful tool for brand growth. Younger audiences in particular browse TikTok for entertainment, product inspiration and peer recommendations.
                </p>
                <p className="mt-4 text-[#555] text-[16px] md:text-[18px] max-w-[600px] mx-auto font-bold">
                    By using a strategic TikTok marketing service, you can:
                </p>
            </div>


            {/* CRO Points Grid */}
            <div className="flex flex-wrap justify-center gap-8 md:gap-12 w-[90%] md:w-[85%] mx-auto">
                {croPoints.map((point, index) => (
                    <div
                        key={index}
                        className={`p-6 w-full sm:w-[45%] md:w-[30%] rounded-2xl shadow-md text-left transition ${index % 2 === 0
                            ? "bg-[#E42E35] text-white" // red card
                            : "bg-white text-[#151515]" // white card
                            }`}
                    >
                        <h3 className="text-[18px] md:text-[20px] font-bold mb-3">
                            {point.title}
                        </h3>
                        <p className="text-[14px] md:text-[15px] leading-[22px]">
                            {point.description}
                        </p>
                    </div>
                ))}
            </div>



            {/* Summary */}
            <div className="text-center mt-12 max-w-2xl mx-auto">
                <p className="text-[#151515] !text-[16px] md:!text-[18px] font-semibold">
                    If your business in Dubai or across the UAE is ready to increase engagement, grow your brand and boost conversions, TikTok marketing offers a unique opportunity.
                </p>
            </div>
        </div>
    );
}
